import { Component, inject, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { RouterLink } from "@angular/router";
import { InternationalizationService } from "@app/core/services";

@Component({
  selector: "app-credits",
  templateUrl: "./credits.component.html",
  styleUrls: ["./credits.component.scss"],
  imports: [RouterLink],
})
export class CreditsComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  i18n = inject(InternationalizationService);
  credits: SafeHtml;
  ngOnInit(): void {
    this.credits = this.sanitizer.bypassSecurityTrustHtml(
      this.i18n.str(
        "challengeu.credits_content",
        `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
      Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    `
      )()
    );
  }
}
